<script lang="ts" setup>
import { useLocalStorage } from '@vueuse/core'
import { ref } from 'vue'
import Breadcrumb from '../components/ui/breadcrumb/Breadcrumb.vue'
const crumbs = ref([
	{ name: 'Cadastro', step: 0 },
	{ name: 'Planejamento', step: 1 },
])

const recuo = useLocalStorage('storageRecuo', 0)

const step = ref(1)
</script>

<template>
	<div>
		<div class="container__nav__revisao">
			<Breadcrumb
				v-model="step"
				:style="{ marginLeft: recuo + '%' }"
				:crumbs="crumbs"
				class="breadcrumb__internal"
			/>
			<div
				style="display: flex"
				class="w-fit gap-4"
			>
				<slot name="actions" />
			</div>
		</div>
		<div class="relative">
			<slot />
		</div>
		<slot name="colapsable" />
	</div>
</template>

<style scoped>
.container__nav__revisao {
	@apply flex justify-between px-8 py-2 items-center bg-white-neutral relative;
}
</style>
